import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Link, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import axios from '~/utils/axios';

import Banner from '../components/banner';

export default function FailedRebillBanner() {
  const [failedSubs, setFailedSubs] = useState([]);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const getFailedRebills = async () => {
      try {
        const response = await axios.get('/me/billing-v2/failedRebills');
        setFailedSubs(response?.data?.subscriptionIds ?? []);
      } catch (err) {
        console.error('Error fetching subscriptions rebill status', err);
      }
    };

    getFailedRebills();
  }, []);

  if (!visible || failedSubs.length === 0) return null;

  return (
    <Banner isCritical>
      <Box
        display="flex"
        flexDirection={['column', 'row']}
        justifyContent="space-between"
        alignItems={['flex-start', 'center']}
        width="100%"
        gap={1}
      >
        <Box flex="1 1 auto" minWidth={0}>
          <Typography component="span" variant="body1" fontWeight="bold">
            Unable to process subscription payment
          </Typography>
          {` – We couldn’t process your recent payment for the following subscription${
            failedSubs.length > 1 ? 's' : ''
          }: ${failedSubs.join(', ')}. Please `}
          <Link
            component={RouterLink}
            to="/dashboard/profile/billing"
            sx={{ color: 'primary.dark', textDecoration: 'underline' }}
          >
            update your billing info
          </Link>
          {' to avoid service interruption.'}
        </Box>

        <IconButton
          aria-label="close"
          onClick={() => setVisible(false)}
          size="small"
          sx={{
            mt: 0,
            alignSelf: ['flex-end', 'flex-start'],
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    </Banner>
  );
}
